export function getCdnUrl(
  hash: string,
  width = 1000,
  height = 1000,
  quality = 75
) {
  const CDN_URL = process.env.REACT_APP_CDN_URL;
  return `${CDN_URL}${hash}?width=${width}&height=${height}&quality=${quality}`;
}



// WEBPACK FOOTER //
// ./src/utils/cdn.ts